// extracted by mini-css-extract-plugin
module.exports = {"LandingPageCard":"LandingPage_LandingPageCard__3PxR6"};